import React, { FC } from 'react'
import { TagsContainer } from '../style'

//* utils
import { LocaleCodes } from '../../../../../constants/localization.constants'
import { BlogFacebook, BlogLinkedIn, BlogTwitter } from '../../../../../constants/svg'
import { SOCIAL, UIPATH } from '../../../../../constants/urls'
import { generateBlogPostSlug, generateSecondaryBlogSlug } from '../../../../../utils/blog.utils'
import { findTarget } from '../../../../../utils/microcopy.utils'
import { renderRichText } from '../../../../../utils/richTextHandler.utils'

//* components
import Bio from '../../../../global/bio'
import BlogFeaturedResource from '../../../../global/blogFeaturedResource'
import Typography from '../../../../global/typography'

type Props = {
  blogData: any
  blogCategoryFormatted: string
}

export const PostContent: FC<Props> = ({ blogData, blogCategoryFormatted }) => {
  const topicsLABEL = () => {
    let label = ''

    if (blogData.node_locale === LocaleCodes.ENGLISH.code) {
      label = `resource.3.TopicsLABEL.text`
    } else if (blogData.node_locale === LocaleCodes.JAPANESE.code) {
      label = `resource.JA.123.TopicsLABEL.text`
    } else if (blogData.node_locale === LocaleCodes.KOREAN.code) {
      label = `resource.KO.143.TopicsLABEL.text`
    } else if (blogData.node_locale === LocaleCodes.GERMAN.code) {
      label = `resource.DE.23.TopicsLABEL.text`
    } else if (blogData.node_locale === LocaleCodes.FRENCH.code) {
      label = `resource.FR.43.TopicsLABEL.text`
    } else if (blogData.node_locale === LocaleCodes.PORTUGUESE.code) {
      label = `resource.PT.63.TopicsLABEL.text`
    } else if (blogData.node_locale === LocaleCodes.SPANISH.code) {
      label = `resource.ES.83.TopicsLABEL.text`
    } else if (blogData.node_locale === LocaleCodes.CHINESE.code) {
      label = `resource.CN.103.TopicsLABEL.text`
    }

    return label
  }

  const formattedBlogTags =
    blogData.tags.map((tag: any) => {
      let tagName = tag.overwriteUrlText || tag.title

      if (tagName === 'Digital Transformation') {
        tagName = 'digital-business-transformation'
      } else if (tagName === 'Automation') {
        tagName = 'enterprise-automation'
      } else if (tagName === 'Finance & Accounting (F&A)') {
        tagName = 'finance-and-accounting'
      } else if (tagName === 'Robotic Process Automation (RPA)') {
        tagName = 'robotic-process-automation'
      } else if (tagName === 'Artificial Intelligence (AI)') {
        tagName = 'artificial-intelligence'
      }

      if (blogData.isSecondaryBlog) {
        tag.url = generateSecondaryBlogSlug({
          slug: '',
          blogCategoryName: tagName,
          useCase: blogData.category.useCase,
          pageLocale: blogData.node_locale,
        })
      } else {
        tag.url = generateBlogPostSlug({
          slug: '',
          blogCategoryName: tagName,
          pageLocale: blogData.node_locale,
          isCollectionListing: true,
        })
      }

      return tag
    }) || []

  return (
    <div className="BlogPost__Post-Container">
      {blogData.name && blogCategoryFormatted && blogData.slug && (
        <div className="BlogPost__SocialMedia-Container">
          <a
            className="BlogPost__SocialMedia-Item"
            target="_blank"
            href={`${
              SOCIAL.TWITTER
            }/intent/tweet?original_referer=https%3A%2F%2Fwww.uipath.com%2F&ref_src=twsrc%5Etfw&text=${blogData.name
              .split(' ')
              .join('+')}&tw_p=tweetbutton&url=${UIPATH.PROD}${blogData.blogPostPath}`}>
            <BlogTwitter />
          </a>

          <a
            className="BlogPost__SocialMedia-Item"
            target="_blank"
            href={`${SOCIAL.LINKEDIN}/shareArticle?mini=true&url=${UIPATH.PROD}${
              blogData.blogPostPath
            }&title=text=${blogData.name.split(' ').join('%20')}&summary=${blogData.name
              .split(' ')
              .join('%20')}&source=https%3A%2F%2Fwww.uipath.com`}>
            <BlogLinkedIn />
          </a>

          <a
            className="BlogPost__SocialMedia-Item"
            target="_blank"
            href={`${SOCIAL.FACEBOOK}/sharer/sharer.php?u=${UIPATH.PROD}${blogData.blogPostPath}&display=popup&ref=plugin&src=like&kid_directed_site=0`}>
            <BlogFacebook />
          </a>
        </div>
      )}

      <div className="BlogPost__Body-Container">
        <div className="BlogPost__Body">{blogData.body && renderRichText(blogData.body)}</div>

        <BlogFeaturedResource data={blogData.featuredResources[0]} />

        {formattedBlogTags?.length > 0 ? (
          <TagsContainer>
            <div className="Tags__Group">
              <Typography type="label" className="Tags__Heading">
                {findTarget(topicsLABEL(), blogData.generics) || 'Topics:'}
              </Typography>

              {formattedBlogTags.map((tag: any) => (
                <a key={tag.title} className="Tag" href={tag.url}>
                  {tag.title}
                </a>
              ))}
            </div>
          </TagsContainer>
        ) : null}

        <div className="BlogPost__Author">
          <Bio
            data={blogData.author}
            type="bioShortDescription"
            locale={blogData.node_locale}
            isSecondaryBlog={blogData.isSecondaryBlog}
            useCase={blogData.category.useCase}
          />
        </div>
      </div>
    </div>
  )
}
